import Fullscreen from '@mui/icons-material/Fullscreen';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function FullscreenIcon(props: FixMe) {
  return <Fullscreen {...props} />;
}

export default FullscreenIcon;
